window.addEventListener('load', () => {  
  const variantInputs = document.querySelectorAll('.product__info-wrapper variant-selects input');
  variantInputs.forEach((variant) => {
    variant.removeAttribute('checked', '');
  })
});
